import { useEffect, useState } from "react";
import {
  getContentAnalytics,
  getOrgChartAnalytics,
  getOrgDashboardCount,
} from "../../store/dashboard/dashboard.action";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as UserTotalIcon } from "../../assets/icons/UserSideBarIcon.svg";
import { ReactComponent as DashboardIcon } from "../../assets/sidebarIcon/Category.svg";
import { ReactComponent as VideoIcon } from "../../assets/icons/VideoIcon.svg";
import { ReactComponent as ReportIcon } from "../../assets/sidebarIcon/Report.svg";
import { useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import dayjs from "dayjs";

const OrgDashboard = () => {
  const dispatch = useDispatch();
  const {
    orgDashboardCount,
    orgContestCount,
    chartAnalyticOfOrgVideos,
    chartAnalyticOfOrgMembers,
    chartAnalyticOfOrgCourse,
    chartAnalyticOfOrgCourseEnrollment,
  } = useSelector((state) => state.dashboard);

  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  let labelSet = new Set();
  let videoMap = new Map();
  let memberMap = new Map();
  let courseMap = new Map();

  let enrollmentLabel = new Set();
  let enrollmentMap = new Map();
  let completionMap = new Map();
  let certifiedMap = new Map();

  chartAnalyticOfOrgVideos?.forEach((data) => {
    const newDate = new Date(data?.date);
    const date = dayjs(newDate).format("YYYY-MM-DD");
    labelSet.add(date);
    videoMap.has(date)
      ? videoMap.set(date, videoMap.get(date) + data.count)
      : videoMap.set(date, data?.count || 0);
  });

  console.log(orgDashboardCount);

  chartAnalyticOfOrgMembers?.forEach((data) => {
    const newDate = new Date(data?.date);
    const date = dayjs(newDate).format("YYYY-MM-DD");
    labelSet.add(date);
    memberMap.has(date)
      ? memberMap.set(date, memberMap.get(date) + data.count)
      : memberMap.set(date, data?.count || 0);
  });

  chartAnalyticOfOrgCourse?.forEach((data) => {
    const newDate = new Date(data?.date);
    const date = dayjs(newDate).format("YYYY-MM-DD");
    labelSet.add(date);
    courseMap.has(date)
      ? courseMap.set(date, courseMap.get(date) + data.count)
      : courseMap.set(date, data?.count || 0);
  });

  chartAnalyticOfOrgCourseEnrollment?.enrolled?.forEach((data) => {
    const newDate = new Date(data?.date);
    const date = dayjs(newDate).format("YYYY-MM-DD");
    enrollmentLabel.add(date);
    enrollmentMap.has(date)
      ? enrollmentMap.set(date, enrollmentMap.get(date) + data.count)
      : enrollmentMap.set(date, data?.count || 0);
  });

  chartAnalyticOfOrgCourseEnrollment?.completed?.forEach((data) => {
    const newDate = new Date(data?.date);
    const date = dayjs(newDate).format("YYYY-MM-DD");
    enrollmentLabel.add(date);
    completionMap.has(date)
      ? completionMap.set(date, completionMap.get(date) + data.count)
      : completionMap.set(date, data?.count || 0);
  });

  chartAnalyticOfOrgCourseEnrollment?.certified?.forEach((data) => {
    const newDate = new Date(data?.date);
    const date = dayjs(newDate).format("YYYY-MM-DD");
    enrollmentLabel.add(date);
    certifiedMap.has(date)
      ? certifiedMap.set(date, certifiedMap.get(date) + data.count)
      : certifiedMap.set(date, data?.count || 0);
  });

  labelSet.forEach((label) => {
    if (!videoMap.has(label)) videoMap.set(label, 0);
    if (!memberMap.has(label)) memberMap.set(label, 0);
    if (!courseMap.has(label)) courseMap.set(label, 0);
  });

  enrollmentLabel.forEach((label) => {
    if (!enrollmentMap.has(label)) enrollmentMap.set(label, 0);
    if (!completionMap.has(label)) completionMap.set(label, 0);
    if (!certifiedMap.has(label)) certifiedMap.set(label, 0);
  });

  const chartOptions = {
    chart: {
      stacked: false,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    yaxis: {
      show: false,
      min: 0,
    },
    xaxis: {
      categories: Array.from(labelSet),
      rotate: 0,
      rotateAlways: true,
      minHeight: 50,
      maxHeight: 100,
      labels: {
        offsetX: -4, // Adjust the offset vertically
        fontSize: 10,
      },
    },
    tooltip: {
      shared: true,
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetX: -10,
    },
    colors: ["#FD4D66", "#786D81", "#e91e63"],
  };

  const enrollmentChartOptions = {
    chart: {
      stacked: false,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    title: {
      text: "Course Enrollments",
      style: {
        fontSize: "16px",
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    yaxis: {
      show: false,
      min: 0,
    },
    xaxis: {
      categories: Array.from(enrollmentLabel).sort(
        (a, b) => new Date(a) - new Date(b),
      ),
      rotate: 0,
      rotateAlways: true,
      minHeight: 50,
      maxHeight: 100,
      labels: {
        offsetX: -4, // Adjust the offset vertically
        fontSize: 10,
      },
    },
    tooltip: {
      shared: true,
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      offsetX: -10,
    },
    colors: ["#FD4D66", "#4A9EF1", "#ff4d00"],
  };

  const enrollmentSeries = [
    {
      name: "Enrolled",
      data: Array.from(enrollmentMap)
        .sort((a, b) => new Date(a[0]) - new Date(b[0]))
        .map(([key, value]) => value),
    },
    {
      name: "Completed",
      data: Array.from(completionMap)
        .sort((a, b) => new Date(a[0]) - new Date(b[0]))
        .map(([key, value]) => value),
    },
    {
      name: "Certified",
      data: Array.from(certifiedMap)
        .sort((a, b) => new Date(a[0]) - new Date(b[0]))
        .map(([key, value]) => value),
    },
  ];

  const series = [
    {
      name: "Members",
      data: Array.from(memberMap)
        .sort((a, b) => new Date(a[0]) - new Date(b[0]))
        .map(([key, value]) => value),
    },
    {
      name: "Video",
      data: Array.from(videoMap)
        .sort((a, b) => new Date(a[0]) - new Date(b[0]))
        .map(([key, value]) => value),
    },
    {
      name: "Course",
      data: Array.from(courseMap)
        .sort((a, b) => new Date(a[0]) - new Date(b[0]))
        .map(([key, value]) => value),
    },
  ];

  const fetchDashboardCount = () => {
    dispatch(getOrgDashboardCount(startDate, endDate));
    dispatch(getContentAnalytics(startDate, endDate));
    dispatch(getOrgChartAnalytics("video", startDate, endDate));
    dispatch(getOrgChartAnalytics("member", startDate, endDate));
    dispatch(getOrgChartAnalytics("course", startDate, endDate));
    dispatch(getOrgChartAnalytics("enrollment", startDate, endDate));
  };

  useEffect(() => {
    fetchDashboardCount();
  }, [dispatch, startDate, endDate]);

  return (
    <PageContainer className="dashboard">
      <PageHeader
        showDateRange={true}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      <div className="dashBoardMain px-4 pt-2">
        <div className="row dashboard-count-box">
          <CountCard
            title="Total Members"
            count={orgDashboardCount?.totalOrgMembers || 0}
            url="/org/members"
            icon={<UserTotalIcon />}
          />
          <CountCard
            title="Total Departments"
            count={orgDashboardCount?.totalDepartments || 0}
            url="/org/departments"
            icon={<DashboardIcon />}
          />
          <CountCard
            title="Total Videos"
            count={orgDashboardCount?.totalVideos || 0}
            url="/org/videos"
            icon={<VideoIcon />}
          />
          <CountCard
            title="Total Courses"
            count={orgDashboardCount?.totalCourses || 0}
            url="/org/courses"
            icon={<ReportIcon />}
          />
          <CountCard
            title="Total Courses Enrollments"
            count={orgDashboardCount?.totalEnrollments || 0}
            icon={<ReportIcon />}
          />
          <CountCard
            title="Total Courses Completions"
            count={orgDashboardCount?.totalCourseCompletions || 0}
            icon={<ReportIcon />}
          />
          <CountCard
            title="Total Certificates Received"
            count={orgDashboardCount?.totalCertificatesReceived || 0}
            icon={<ReportIcon />}
          />
        </div>

        <div className="dashboard-analytics">
          <h6 className="heading-dashboard">Contest Analytics</h6>
          <div className="row dashboard-count-box">
            <CountCard
              title="Total Courses Enrollments"
              count={orgContestCount?.totalEnrollments || 0}
              icon={<ReportIcon />}
            />
            <CountCard
              title="Total Courses Completions"
              count={orgContestCount?.totalCourseCompletions || 0}
              icon={<ReportIcon />}
            />
            <CountCard
              title="Total Certificates Received"
              count={orgContestCount?.totalCertificatesReceived || 0}
              icon={<ReportIcon />}
            />
          </div>
        </div>

        <div className="dashboard-analytics">
          <h6 className="heading-dashboard">Data Analytics</h6>
          <div className="row dashboard-chart justify-content-between gap-5">
            <div className="col-md-12 col-sm-12 mt-lg-0 mt-4 position-relative dashboard-chart-box">
              <div id="chart" className="dashboard-user-count h-100 p-4">
                <ReactApexChart
                  options={enrollmentChartOptions}
                  series={enrollmentSeries}
                  type="area"
                  height={"450px"}
                />
              </div>
            </div>
            <div className="col-md-12 col-sm-12 mt-lg-0 mt-4 position-relative dashboard-chart-box">
              <div id="chart" className="dashboard-user-count h-100 p-4">
                <ReactApexChart
                  options={chartOptions}
                  series={series}
                  type="area"
                  height={"450px"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

const CountCard = ({ url, title, count, icon }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`adminProfileBox px-2 col-lg-3 col-md-6 col-sm-12 ${url ? "cursor" : ""}`}
      onClick={() => url && navigate(url)}
    >
      <div className="dashBoxData bg-white">
        <div className="icon icon-sm icon-shape-small text-center border-radius-xl my-auto icon-data1">
          {icon}
        </div>
        <div className="dashBox-text">
          <h5 className="text-center">{title}</h5>
          <h6 className="text-center pt-3  fw-bold">{count}</h6>
        </div>
      </div>
    </div>
  );
};

export default OrgDashboard;
